const delay = (n) => {
  return new Promise((resolve) => {
    setTimeout(resolve, n);
  });
};

export const myAsyncFunction = async () => {
  await delay(1000);
};
